module.exports = __webpack_public_path__ + "img/icon-search-black.c140ff44.svg";